<template>
  <v-card>
    <div class="d-flex flex-column complaint-log-container">
      <!-- Title -->
      <v-toolbar class="flex-none" color="primary" dark>
        <v-toolbar-title>Complaint Log</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('on-close-click')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
        height="3"
        class="flex-none"
        style="margin: 0"
      />

      <!-- Content -->
      <div
        class="d-flex flex-row flex-xs-column flex px-4 py-2"
        style="overflow-y: auto"
      >
        <!-- Activities Tracking -->
        <div class="d-flex flex-column flex-none" style="max-width: 21.875em">
          <!-- Title -->
          <h3 class="flex-none">
            {{ "Complaint  ID - " + (complaint && complaint.id) }}
          </h3>

          <!-- Timeline -->
          <div ref="timeline" class="flex scroll-y px-2 py-1">
            <v-timeline v-if="complaint" small align-top dense>
              <!-- Activities -->
              <v-timeline-item
                style="padding-bottom: 0;"
                v-for="(activity, i) of complaint.activities"
                :key="i"
                fill-dot
                small
              >
                <!--  -->
                <div
                  column
                  wrap
                  class="box-done"
                  :style="{ backgroundColor: activityColor(activity.type) }"
                >
                  <!-- Actity name -->
                  <strong>{{ activity.type && activity.type.name }}</strong>

                  <v-divider
                    style="margin: 0.3125em -0.3125em; background: #ffffff"
                  />

                  <!-- Content -->
                  <div
                    style="display: inline-flex; align-items: center; font-style: italic"
                  >
                    <!-- Allotted to Ground Staff -->
                    <div
                      class="d-flex"
                      v-if="
                        activity.type &&
                          activity.type.name ===
                            ACTIVITY_TYPES.ALLOTTED_TO_GROUND_STAFF
                      "
                    >
                      <v-avatar class="flex-none">
                        <img
                          v-if="activity.user && activity.user.avatar"
                          style="width: 100%; height: 100%; object-fit: contain;"
                          :src="activity.user.avatar"
                        />
                        <v-icon dark style="font-size: 3em" v-else
                          >account_circle</v-icon
                        >
                      </v-avatar>

                      <div class="ml-1">
                        <div class="font-weight-bold">
                          {{
                            activity.assigned_user &&
                              activity.assigned_user.name
                          }}
                        </div>

                        <div>
                          +91-{{
                            activity.assigned_user &&
                              activity.assigned_user.mobile
                          }}
                        </div>
                      </div>
                    </div>

                    <!-- Comment -->
                    <div
                      class="d-flex"
                      v-else-if="
                        activity.type &&
                          activity.type.name === ACTIVITY_TYPES.COMMENT
                      "
                    >
                      <v-avatar class="flex-none">
                        <img
                          v-if="activity.user && activity.user.avatar"
                          :src="activity.user.avatar"
                        />
                        <v-icon dark style="font-size: 3em" v-else
                          >account_circle</v-icon
                        >
                      </v-avatar>

                      <div class="ml-1">
                        <div class="font-weight-bold">
                          {{ activity.user && activity.user.name }}
                        </div>

                        <div>{{ activity.remarks }}</div>
                      </div>
                    </div>

                    <!-- Issue Raised -->
                    <div
                      class="d-flex"
                      v-else-if="
                        activity.type &&
                          activity.type.name === ACTIVITY_TYPES.ISSUE_RAISED
                      "
                    >
                      <v-avatar class="flex-none">
                        <img
                          v-if="activity.user && activity.user.avatar"
                          :src="activity.user.avatar"
                        />
                        <v-icon dark style="font-size: 3em" v-else
                          >account_circle</v-icon
                        >
                      </v-avatar>

                      <div class="ml-1">
                        <div class="font-weight-bold">
                          {{ activity.user && activity.user.name }}
                        </div>
                        <div>
                          +91-{{ activity.user && activity.user.mobile }}
                        </div>
                      </div>
                    </div>

                    <!-- Other -->
                    <div v-else class="d-flex">
                      <v-avatar class="flex-none">
                        <img
                          v-if="activity.user && activity.user.avatar"
                          :src="activity.user.avatar"
                        />
                        <v-icon dark style="font-size: 3em" v-else
                          >account_circle</v-icon
                        >
                      </v-avatar>

                      <div class="ml-1">
                        <div class="font-weight-bold">
                          {{ activity.user && activity.user.name }}
                        </div>

                        <div>
                          +91-{{ activity.user && activity.user.mobile }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Time -->
                <div class="caption">
                  {{ convertDateTime(activity.created_at) }}
                </div>
              </v-timeline-item>
            </v-timeline>
          </div>

          <!-- Comments -->
          <div class="flex-none font-weight-bold subheading mt-2">
            Comment
          </div>

          <v-text-field
            v-model="comment"
            class="flex-none"
            hide-details
            solo
            single-line
            placeholder="Leave a Comment"
            @keydown.enter="attemptComment"
          >
            <template v-slot:append>
              <v-btn
                :loading="commentLoading"
                icon
                :disabled="!comment"
                @click="attemptComment"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <!-- Current Status -->
          <div class="status-text">
            Track Status -
            <span
              v-if="complaint"
              class="font-weight-bold"
              :style="{ color: complaint.status && complaint.status.color }"
            >
              {{ complaint.status && complaint.status.name }}
            </span>
          </div>
        </div>

        <!-- Info -->
        <div class="flex" style="margin-left: 2.5em;" column>
          <!-- Tabs -->
          <div class="d-flex title">
            <div
              class="touchable-highlight"
              style="text-align: center"
              :class="{
                'touchable-highlight--highlight': viewMode === mode,
                'selected-tab': viewMode === mode
              }"
              v-for="mode of viewModes"
              :key="mode"
              @click="viewMode = mode"
            >
              {{ mode }}
            </div>
          </div>

          <v-divider class="my-2" />

          <!-- For Citizen -->
          <div v-if="viewMode === 'CITIZEN'" key="CITIZEN" class="px-2 py-1">
            <!-- District -->
            <div class="font-weight-bold subheading">District</div>
            <v-text-field
              single-line
              small
              outline
              disabled
              hide-details
              :value="
                (complaint && complaint.ward && complaint.ward.dist_name) ||
                  'Out of Ward'
              "
            />

            <!-- Ward -->
            <div class="font-weight-bold subheading mt-2">Ward</div>
            <v-text-field
              single-line
              small
              outline
              disabled
              hide-details
              :value="
                (complaint && complaint.ward && complaint.ward.name) ||
                  'Out of Ward'
              "
            />

            <!-- Images -->
            <div class="font-weight-bold subheading mt-2">Images</div>
            <div
              v-if="issueRaisedActivity"
              class="d-flex"
              style="overflow-x: auto"
            >
              <img
                class="mr-2"
                style="max-width: 12.5em; max-height: 12.5em; object-fit: cover"
                v-for="(image, i) of issueRaisedActivity.images"
                :key="i"
                :src="image.url"
              />
            </div>

            <!-- Nature of Complaint -->
            <div class="font-weight-bold subheading mt-2">
              Nature of Complaint
            </div>
            <v-text-field
              single-line
              small
              outline
              disabled
              hide-details
              :value="
                (complaint && complaint.nature && complaint.nature.name) ||
                  (complaint && complaint.nature_string)
              "
            />

            <!-- Description -->
            <div class="font-weight-bold subheading mt-2">Remarks</div>
            <v-textarea
              outline
              disabled
              hide-details
              :value="complaint.remarks"
            />
          </div>

          <div v-else-if="viewMode === 'STAFF'" key="STAFF" class="px-2 py-1">
            <!-- Images -->
            <div class="font-weight-bold subheading mt-2">Images</div>
            <div
              v-if="issueStaffActivities"
              class="d-flex"
              style="overflow-x: auto"
            >
              <img
                class="mr-2"
                style="max-width: 12.5em; max-height: 12.5em; object-fit: cover"
                v-for="(image, i) of issueStaffActivities
                  .map(a => a.images)
                  .flat()"
                :key="i"
                :src="image.url"
              />
            </div>

            <!-- Description -->
            <div class="font-weight-bold subheading mt-2">Description</div>
            <v-textarea
              outline
              disabled
              hide-details
              :value="
                issueStaffActivities &&
                  issueStaffActivities
                    .map(a => a.remarks)
                    .flat()
                    .join('\n')
              "
            />
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import api from "@/api";

import { ACTIVITY_TYPES } from "@/constants/complaints";

export default {
  data() {
    return {
      commentLoading: false,
      comment: undefined,

      viewMode: "CITIZEN",
      viewModes: ["CITIZEN", "STAFF"]
    };
  },

  props: {
    complaint: {
      type: Object,
      default: undefined
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    issueRaisedActivity() {
      if (!this.complaint) return null;

      return this.complaint.activities.find(
        a => a.type && a.type.name === ACTIVITY_TYPES.ISSUE_RAISED
      );
    },

    issueStaffActivities() {
      if (!this.complaint) return null;

      return this.complaint.activities.filter(
        a =>
          a.type &&
          [ACTIVITY_TYPES.ISSUE_RESOLVED, ACTIVITY_TYPES.IN_PROGRESS].includes(
            a.type.name
          )
      );
    },

    ACTIVITY_TYPES() {
      return ACTIVITY_TYPES;
    }
  },

  methods: {
    convertDate(utcStr) {
      return moment(
        moment.parseZone(utcStr, "YYYY-MM-DD HH:mm:ss", "UTC").toDate()
      ).format("hh:mm A | MMMM DD, YYYY");
    },

    convertDateTime(utcStr) {
      return this.convertDate(utcStr);
    },

    async attemptComment() {
      try {
        this.commentLoading = true;

        if (!this.complaint) return;

        const res = await api.addComplaintComment(this.complaint.id, {
          remarks: this.comment
        });

        this.comment = undefined;
        this.complaint.activities.push(res.data.data);

        this.$emit("new-comment", res.data.data);

        this.$nextTick(() => {
          this.scrollTimelineContainerToBottom();
        });
      } finally {
        this.commentLoading = false;
      }
    },

    activityColor(type) {
      if (!type) {
        // console.error("Activity type is null");
        return;
      }

      switch (type.name) {
        case ACTIVITY_TYPES.ISSUE_RAISED:
          return "var(--danger)";
        case ACTIVITY_TYPES.RECEIVED_BY_DEPARTMENT:
          return "#00bdbd";
        case ACTIVITY_TYPES.ALLOTTED_TO_GROUND_STAFF:
          return "var(--info)";
        case ACTIVITY_TYPES.ISSUE_RESOLVED:
          return "var(--success)";
        case ACTIVITY_TYPES.COMMENT:
          return "#5e5e5e";
        case ACTIVITY_TYPES.IN_PROGRESS:
          return "var(--warning)";
        default:
          return "#5e5e5e";
      }
    },

    scrollTimelineContainerToBottom() {
      this.$refs.timeline.scrollTop = this.$refs.timeline.scrollHeight;
    }
  }
};
</script>

<style lang="css" scoped>
.status-text {
  margin: 0.625em 0.625em;
}

.caption {
  padding: 0.3125em 0.625em;
  font-style: italic;
}

.box {
  margin-top: 0.3125em;
  padding: 0.625em;
  background-color: #f7f7f7;
  border-radius: 0.3125em;
  color: gray;
}

.box-done {
  margin-top: 0.3125em;
  padding: 0.625em;
  border-radius: 0.3125em;
  color: white;
}

.selected-tab {
  text-decoration: underline;
}

.complaint-log-container {
  height: 90vh;
}
</style>
